import { render, staticRenderFns } from "./ValidateContentPage.vue?vue&type=template&id=57c88645&"
import script from "./ValidateContentPage.vue?vue&type=script&lang=ts&"
export * from "./ValidateContentPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports